jQuery(document).ready(function($) {

	// shows and hides filtered items
	$(".filter-simple-button").click(function() {
		var value = $(this).attr('data-filter');
		if(value === "all") {
			$('.rooms-listitem').show('1000');
		} else {
			$(".rooms-listitem").not('.'+value).hide('2000');
			$('.rooms-listitem').filter('.'+value).show('2000');
		}
	});

// changes active class on filter buttons
	$('.filter-simple-button').click(function () {
		$(this).siblings().removeClass('is-active');
		$(this).addClass('is-active');
	});

	// Moving labels on focus in form
	jQuery('input').each(function() {

		jQuery(this).on('focus', function() {
			jQuery(this).parent().parent('.gfield').addClass('active');
		});

		jQuery(this).on('blur', function() {
			if (jQuery(this).val().length == 0) {
				jQuery(this).parent().parent('.gfield').removeClass('active');
			}
		});

		if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active');

	});
	jQuery('textarea').each(function() {

		jQuery(this).on('focus', function() {
			jQuery(this).parent().parent('.gfield').addClass('active');
		});

		jQuery(this).on('blur', function() {
			if (jQuery(this).val().length == 0) {
				jQuery(this).parent().parent('.gfield').removeClass('active');
			}
		});

		if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active');

	});
    jQuery('body').addClass('js');
    var $menu = jQuery('#menu'), // wrapper to change class on
        $menulink = jQuery('.menu-link');

    $menulink.click(function() {
        $menulink.toggleClass('active');
        $menu.toggleClass('active');
        return false;
    });

	// OWL
    var owl = jQuery('.oks-slideshow');
    var dots_label = [];

    jQuery.each(jQuery(owl).find('.oks-slide'), function (i) {
        dots_label.push(jQuery(this).find('.nav-header').text());
    });

    function customPager() {
        jQuery.each(jQuery(owl).find('.owl-dot'), function (i) {
            var paginationLinks = jQuery('.owl-dots .owl-dot span');
            jQuery(paginationLinks[i]).text(dots_label[i]);
        });
    }

    function addLayoutBody(event) { // Adding the correct layout for each slide to the body
        var activeSlideLayout = jQuery(document).find('section.active .owl-item.active').find('.oks-slide').data('layout');

        var $body = jQuery('body')[0];

        if($body.dataset.layout) {
            $body.classList.remove($body.dataset.layout);
        }
        $body.dataset.layout = activeSlideLayout;
        $body.classList.add(activeSlideLayout);
    }

	owl.owlCarousel({
		items: 1,
		loop: true,
		responsive : {
			0 : {
				nav: true,
				dots: false,
				navText: ['<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-prev"/>','<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-next"/>']

			},
			1024 : {
				nav: false,
				dots: true,
				onInitialized : customPager,
				onTranslated: addLayoutBody
			}
		}
	});
	jQuery('.rel-success').owlCarousel({
		items: 1,
		loop: true,
		dots: false,
		nav: true,
		navText: ['<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-prev"/>','<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-next"/>'],
		responsive : {
			0 : {
                autoHeight:true
        	},
			1024 : {
                autoHeight:false
            },
		}
	});
	jQuery('.slideshow-reg').owlCarousel({
		items: 1,
		loop: true,
		dots: true,
		nav: true,
		navText: ['<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-prev"/>','<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-next"/>']
	});
	jQuery('.rel-artikler').owlCarousel({
		loop: true,
		dots: false,
		nav: true,
		navText: ['<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-prev"/>','<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-next"/>'],
		responsive : {
			0 : {
				items: 1
			},
			1024 : {
				items: 3,
				margin: 60,
				center: true,
				stagePadding: 140
			},
			2200 : {
				items: 5,
				margin: 60,
				center: true,
				stagePadding: 140
			}
		}
	});
	jQuery('.rel-slideshow').owlCarousel({
        loop: true,
        dots: false,
        nav: true,
		navText: ['<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-prev"/>','<img src="/wp-content/themes/oks-theme/assets/images/simple-arrow.svg" class="arrow-next"/>'],
        responsive : {
            0 : {
                items: 1
        	},
			1024 : {
                items: 3,
                margin: 60,
                center: true,
                stagePadding: 140
            },
			2200 : {
				items: 5,
				margin: 60,
				center: true,
				stagePadding: 140
			}
        }
    });


	jQuery('.grid').masonry({
		// set itemSelector so .grid-sizer is not used in layout
		itemSelector: '.grid-item',
		// use element for option
		columnWidth: '.grid-sizer',
		percentPosition: true
	})
	// Adds class to button if pointing to Matterport
	jQuery( ".readmore-button a" ).each( function() {
		var str = 'matterport';
		if(jQuery(this)[0].hostname.split('.').indexOf(str) > -1) {
			jQuery(this).addClass("matterport");
		}
	});

});
var cont = 0;

var myFullpage = new fullpage('#scroll-page', {
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',

	//Navigation
	menu: '#scroll-menu',
	lockAnchors: false,
//	anchors:['firstPage', 'secondPage'],
	navigation: true,
	navigationPosition: 'right',
//	navigationTooltips: ['firstSlide', 'secondSlide'],
	showActiveTooltip: true,
	slidesNavigation: false,
	slidesNavPosition: 'top',

	//Scrolling
	css3: true,
	scrollingSpeed: 700,
	autoScrolling: false,
	fitToSection: false,
	fitToSectionDelay: 1000,
	scrollBar: false,
	easing: 'easeInOutCubic',
	easingcss3: 'ease',
	loopBottom: false,
	loopTop: false,
	loopHorizontal: true,
	continuousVertical: false,
	continuousHorizontal: false,
	scrollHorizontally: false,
	interlockedSlides: false,
	dragAndMove: false,
	offsetSections: false,
	resetSliders: false,
	fadingEffect: false,
//	normalScrollElements: '.footer',
	scrollOverflow: true,
	scrollOverflowReset: false,
	scrollOverflowOptions: null,
	touchSensitivity: 32,
	normalScrollElementTouchThreshold: 10,
	bigSectionsDestination: null,

	//Accessibility
	keyboardScrolling: true,
	animateAnchor: true,
	recordHistory: true,

	//Design
	controlArrows: true,
	verticalCentered: true,
//	sectionsColor : ['#cccccc', '#fff'],
//	paddingTop: '3em',
//	paddingBottom: '10px',
//	fixedElements: '.footer',
	responsiveWidth: 1024,
//	responsiveHeight: 1500,
	responsiveSlides: false,
	parallax: false,
//	parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},

	//Custom selectors
	sectionSelector: '.section',
//	slideSelector: '.slide',

	lazyLoading: true,

	//events
	onLeave: function(origin, destination, direction, trigger){

        var $body = jQuery('body')[0];
        if($body.dataset.layout) {
            $body.classList.remove($body.dataset.layout);
		}
        var $layout = destination.item.dataset.layout;

//        $body.classList.remove(origin.item.dataset.layout);
        if($layout == 'oks-slideshow'){
        	$layout = destination.item.getElementsByClassName('owl-item active')[0].firstElementChild.dataset.layout;
            $body.dataset.layout = $layout;
        }
        if($layout) {
            $body.classList.add($layout);
            $body.dataset.layout = $layout;
        }
		if(destination.isFirst == false){
			jQuery('.scroll-downs').hide();
		}else{
			jQuery('.scroll-downs').show();
		}
		if(origin.anchor=='seksjon-kontaktskjema'){

			cont++;
			if(cont>5){
				cont = 0;
				return true;
			}else{
				return false
			}
		}
	}

	,
	afterLoad: function(origin, destination, direction){	},
	afterRender: function(){
        var scrollPage = jQuery('#scroll-page');
		var activeSectionLayout = scrollPage.find('section.active').data('layout');

		var $body = jQuery('body')[0];

		if($body.dataset.layout) {
			$body.classList.remove($body.dataset.layout);
		}
		if(activeSectionLayout) {
			$body.dataset.layout = activeSectionLayout;
			$body.classList.add(activeSectionLayout);
		}
	},
	afterResize: function(width, height){},
	afterResponsive: function(isResponsive){},
	afterSlideLoad: function(section, origin, destination, direction){},
	onSlideLeave: function(section, origin, destination, direction){}
});
jQuery("#fp-nav ul li").click(function(){
	cont = 6;
});